import { MenuItem } from 'primeng/api';

const PAGES = '/pages';

export const PagesMenuAdminAdvanced: MenuItem[] = [
  {
    label: 'Dashboard',
    icon: 'pi pi-money-bill',
    routerLink: [`${PAGES}/dashboard`]
  },
  {
    label: 'Punto de Venta',
    icon: 'pi pi-shopping-cart',
    items: [
      {
        label: 'Caja Registradora',
        icon: 'pi pi-money-bill',
        routerLink: [`${PAGES}/punto-de-venta/caja-registradora`]
      },
      {
        label: 'Ventas',
        icon: 'pi pi-arrow-up',
        routerLink: [`${PAGES}/punto-de-venta/ventas`]
      }
      // {
      //   label: 'Recibo test',
      //   icon: 'pi pi-arrow-up',
      //   routerLink: [`${PAGES}/punto-de-venta/nota-venta`]
      // }
    ]
  },
  {
    label: 'Comprobantes',
    icon: 'pi pi-play',
    items: [
      {
        label: 'Boletas o Facturas',
        icon: 'pi pi-play',
        items: [
          {
            label: 'Emisiones Pendientes',
            icon: 'pi pi-play',
            routerLink: [`${PAGES}/comprobantes/emisiones-pendientes`]
          },
          {
            label: 'Nota de Crédito',
            icon: 'pi pi-play',
            routerLink: [`${PAGES}/comprobantes/nota-de-credito`]
          }
        ]
      },
      {
        label: 'Notas de Venta',
        icon: 'pi pi-play',
        routerLink: [`${PAGES}/comprobantes/notas-de-venta`]
      }
    ]
  },
  {
    label: 'Operaciones',
    icon: 'pi pi-play',
    items: [
      {
        label: 'Compras',
        icon: 'pi pi-play',
        items: [
          {
            label: 'Orden de Compra',
            icon: 'pi pi-play',
            routerLink: [`${PAGES}/operaciones/genericas/orden-compras`]
          },
          {
            label: 'Recepción',
            icon: 'pi pi-play',
            routerLink: [
              `${PAGES}/operaciones/genericas/orden-compras-recepcion`
            ]
          },
          {
            label: 'Factura',
            icon: 'pi pi-play',
            routerLink: [`${PAGES}/operaciones/genericas/orden-compras-factura`]
          },
          {
            separator: true
          },
          {
            label: 'Registro de Compra Rápida',
            icon: 'pi pi-play',
            routerLink: [`${PAGES}/operaciones/genericas/compras`]
          }
        ]
      },
      {
        separator: true
      },
      {
        label: 'Traslados',
        icon: 'pi pi-play',
        items: [
          {
            label: 'Realizar traslado',
            icon: 'pi pi-play',
            routerLink: [`${PAGES}/operaciones/genericas/traslados`]
          },
          {
            label: 'Traslados pendientes',
            icon: 'pi pi-play',
            routerLink: [`${PAGES}/operaciones/genericas/traslados-pendientes`]
          },
          {
            label: 'Reposición Inteligente',
            icon: 'pi pi-play',
            routerLink: [`${PAGES}/operaciones/reposicion`]
          }
        ]
      },
      {
        separator: true
      },
      {
        label: 'Almacén',
        icon: 'pi pi-play',
        routerLink: [`${PAGES}/gestion/productos-del-almacen`]
      },
      {
        separator: true
      },
      {
        label: 'Inventario',
        icon: 'pi pi-play',
        items: [
          {
            label: 'Ajustar Precio-Stock',
            icon: 'pi pi-play',
            routerLink: [`${PAGES}/inventario/ajuste-precio-stock`]
          },
          {
            label: 'Inventariado',
            icon: 'pi pi-play',
            routerLink: [`${PAGES}/inventario/inventariar`]
          },
          {
            label: 'Inicializar Stock',
            icon: 'pi pi-play',
            routerLink: [`${PAGES}/inventario/crear`]
          }
        ]
      }
    ]
  },
  {
    label: 'Reportes',
    icon: 'pi pi-play',
    items: [
      {
        label: 'Ventas',
        icon: 'pi pi-play',
        routerLink: [`${PAGES}/reportes/ventas`]
      },
      {
        label: 'Traslados',
        icon: 'pi pi-play',
        routerLink: [`${PAGES}/operaciones/genericas/detalles-traslados`]
      },
      {
        label: 'Compras',
        icon: 'pi pi-play',
        routerLink: [`${PAGES}/reportes/compras`]
      },
      {
        label: 'SUNAT',
        icon: 'pi pi-play',
        routerLink: [`${PAGES}/reportes/sunat`]
      }
      // {
      //   label: 'Traslados',
      //   icon: 'pi pi-play',
      //   routerLink: [`${PAGES}/`]
      // },
      // {
      //   label: 'Clientes',
      //   icon: 'pi pi-play',
      //   routerLink: [`${PAGES}/`]
      // },
      // {
      //   label: 'SUNAT',
      //   icon: 'pi pi-play',
      //   routerLink: [`${PAGES}/`]
      // }
    ]
  },
  {
    label: 'Maestros',
    icon: 'pi pi-play',
    items: [
      {
        label: 'Sucursales',
        icon: 'pi pi-play',
        items: [
          {
            label: 'Sucursales',
            icon: 'pi pi-play',
            routerLink: [`${PAGES}/gestion/sucursales`]
          },
          {
            label: 'Puntos de Venta',
            icon: 'pi pi-play',
            routerLink: [`${PAGES}/gestion/puntos-de-venta`]
          }
        ]
      },
      {
        label: 'Productos',
        icon: 'pi pi-play',
        items: [
          {
            label: 'No Regulados',
            icon: 'pi pi-play',
            routerLink: [`${PAGES}/gestion/productos-no-regulados`]
          },
          {
            label: 'Regulados',
            icon: 'pi pi-play',
            routerLink: [`${PAGES}/gestion/productos-regulados`]
          }
          // {
          //   label: 'Maestro Productos',
          //   icon: 'pi pi-play',
          //   routerLink: [`${PAGES}/gestion/productos`]
          // },
          // {
          //   label: 'Maestro Laboratorios',
          //   icon: 'pi pi-play',
          //   routerLink: [`${PAGES}/gestion/laboratorios`]
          // },
          // {
          //   label: 'Maestro Unidades de Medida',
          //   icon: 'pi pi-play',
          //   routerLink: [`${PAGES}/gestion/unidad-medida`]
          // }
        ]
      },
      // {
      //   label: 'Articulos',
      //   icon: 'pi pi-play',
      //   items: [
      //     {
      //       label: 'Maestro Articulos',
      //       icon: 'pi pi-play',
      //       routerLink: [`${PAGES}/gestion/articulos`]
      //     },
      //     {
      //       label: 'Maestro Grupos Terapeuticos',
      //       icon: 'pi pi-play',
      //       routerLink: [`${PAGES}/gestion/grupos-terapeuticos`]
      //     },
      //     {
      //       label: 'Maestro Principios Activos',
      //       icon: 'pi pi-play',
      //       routerLink: [`${PAGES}/gestion/principio-activo`]
      //     }
      //   ]
      // },
      {
        label: 'Clientes',
        icon: 'pi pi-play',
        items: [
          {
            label: 'Clientes',
            icon: 'pi pi-play',
            routerLink: [`${PAGES}/gestion/clientes`]
          }
        ]
      },
      {
        label: 'Compras',
        icon: 'pi pi-play',
        items: [
          {
            label: 'Proveedores',
            icon: 'pi pi-play',
            routerLink: [`${PAGES}/gestion/proveedores`]
          },
          {
            label: 'Productos del Proveedor',
            icon: 'pi pi-play',
            routerLink: [`${PAGES}/gestion/productos-del-proveedor`]
          },
          {
            label: 'Unidades de Medida',
            icon: 'pi pi-play',
            routerLink: [`${PAGES}/gestion/unidad-medida`]
          }
        ]
      },
      {
        label: 'DIGEMID',
        icon: 'pi pi-play',
        items: [
          {
            label: 'Productos',
            icon: 'pi pi-play',
            routerLink: [`${PAGES}/gestion/productos-digemid`]
          }
        ]
      }
    ]
  },
  {
    label: 'Usuarios',
    icon: 'pi pi-user',
    routerLink: [`${PAGES}/gestion/usuarios`]
  }
];
